var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJfaJobFinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 135,
    viewBox: "0 0 160 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11830_26243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.171 129.978C141.906 133.35 145.698 134.857 145.698 134.857C145.698 134.857 146.677 130.896 144.942 127.523C143.207 124.151 139.415 122.644 139.415 122.644C139.415 122.644 138.436 126.605 140.171 129.978Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.429 128.904C144.64 130.921 145.816 134.828 145.816 134.828C145.816 134.828 141.786 135.464 138.574 133.446C135.363 131.429 134.187 127.521 134.187 127.521C134.187 127.521 138.217 126.886 141.429 128.904Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.302 132.522H94.0498L92.9785 123.836L96.3024 123.836L96.302 132.522Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8759 134.705L89.6143 134.705V134.613C89.6143 133.864 89.9121 133.145 90.4422 132.615C90.9722 132.085 91.6911 131.787 92.4407 131.787H92.4409L96.8761 131.787L96.8759 134.705Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.262 132.522H108.01L106.938 123.836L110.262 123.836L110.262 132.522Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.837 134.705L103.575 134.705V134.613C103.575 133.864 103.873 133.145 104.403 132.615C104.933 132.085 105.652 131.787 106.402 131.787H106.402L110.837 131.787L110.837 134.705Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.723 83.5932L99.2918 74.6763L100.433 67.2801L95.1058 65.8105L94.5547 75.7302L101.463 85.1186C101.413 85.4702 101.467 85.8287 101.617 86.1506C101.767 86.4725 102.007 86.744 102.308 86.9322C102.609 87.1205 102.958 87.2174 103.313 87.2111C103.668 87.2049 104.014 87.0958 104.308 86.8971C104.603 86.6984 104.833 86.4186 104.972 86.0917C105.11 85.7647 105.151 85.4045 105.089 85.0549C105.027 84.7052 104.865 84.381 104.623 84.1216C104.38 83.8621 104.068 83.6786 103.723 83.5932V83.5932Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.308 83.5932L117.74 74.6763L116.598 67.2801L121.926 65.8105L122.477 75.7302L115.568 85.1186C115.618 85.4702 115.564 85.8287 115.415 86.1506C115.265 86.4725 115.024 86.744 114.723 86.9322C114.422 87.1205 114.073 87.2174 113.718 87.2111C113.363 87.2049 113.017 87.0958 112.723 86.8971C112.429 86.6984 112.198 86.4186 112.06 86.0917C111.921 85.7647 111.88 85.4045 111.942 85.0549C112.004 84.7052 112.166 84.381 112.409 84.1216C112.651 83.8621 112.964 83.6786 113.308 83.5932V83.5932Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.351 53.1184C113.028 53.1184 115.198 50.9486 115.198 48.2719C115.198 45.5953 113.028 43.4254 110.351 43.4254C107.675 43.4254 105.505 45.5953 105.505 48.2719C105.505 50.9486 107.675 53.1184 110.351 53.1184Z",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.541 48.2459C105.541 48.2459 105.015 47.4572 105.217 46.6078C105.338 46.1255 105.386 45.6278 105.359 45.1314C105.585 44.3955 105.869 43.6787 106.208 42.9876C106.633 42.2191 106.431 41.8955 107.765 41.6528C109.1 41.4101 108.554 39.6708 112.073 41.5517C112.192 41.7174 112.357 41.8443 112.548 41.9163C112.739 41.9883 112.947 42.0022 113.145 41.9561C113.873 41.8146 114.136 42.8258 114.136 42.8258C114.136 42.8258 114.622 42.5427 114.804 42.9471C114.986 43.3516 116.283 42.7044 116.283 45.4347C116.283 48.165 114.806 50.6038 114.806 50.6038C114.806 50.6038 113.769 53.8762 111.363 53.411C108.956 52.9458 108.607 53.2273 106.954 50.1045C106.616 51.0806 106.096 47.3746 105.541 48.2459Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6983 79.5878L99.1364 81.7911C99.1364 81.7911 96.4897 83.07 95.4304 94.555L94.0037 111.776L91.8262 129.823L96.3527 130.174L99.4914 118.741L106.272 94.6992L107.558 112.887L106.128 129.37L110.904 129.553L114.21 111.184C114.21 111.184 119.276 84.2768 116.008 83.4937L115.68 80.69L99.6983 79.5878Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6504 58.8784L106.447 54.5818L113.064 54.9349L120.968 59.6132L117.674 80.1859C117.674 80.1859 119.562 82.297 113.855 81.6772C108.148 81.0573 98.9245 80.5546 98.9245 80.5546C98.9245 80.5546 98.1826 79.0826 99.7671 78.8759C101.352 78.6693 100.027 78.7176 100.027 78.7176C100.027 78.7176 99.0691 75.6431 100.027 75.0437L100.49 68.7294L98.6504 58.8784Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.801 59.1975L98.6507 58.8784L94.0957 67.0045L101.496 70.2675L100.801 59.1975Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.436 60.667L120.968 59.6132L123.487 71.0459L116.651 72.3405L118.436 60.667Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9616 135H159.142C159.196 135 159.247 134.979 159.285 134.941C159.323 134.903 159.345 134.851 159.345 134.797C159.345 134.743 159.323 134.692 159.285 134.654C159.247 134.616 159.196 134.594 159.142 134.594H59.9616C59.9078 134.594 59.8562 134.616 59.8182 134.654C59.7802 134.692 59.7588 134.743 59.7588 134.797C59.7588 134.851 59.7802 134.903 59.8182 134.941C59.8562 134.979 59.9078 135 59.9616 135Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3327 80.6436H23.5742V93.6242H49.3327V80.6436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.289 83.9664H26.6172V84.6333H46.289V83.9664Z",
    fill: "#FFEB63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.289 86.8004H26.6172V87.4673H46.289V86.8004Z",
    fill: "#FFEB63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.289 89.6345H26.6172V90.3014H46.289V89.6345Z",
    fill: "#FFEB63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5352 93.827H23.3711V80.4407H49.5352V93.827ZM23.7767 93.4213H49.1296V80.8463H23.7767V93.4213Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8225 64.5209C25.3692 64.5254 20.0229 63.0077 15.3854 60.1386L15.2676 60.0656L15.3404 59.9478L30.7452 35.0164H60.1884V35.155C60.1884 51.3475 47.0149 64.5209 30.8225 64.5209Z",
    fill: "#FFEB63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.932 53.9349L11.8373 53.8763C6.63981 50.6626 2.89289 45.5566 1.38621 39.6345C-0.120459 33.7123 0.730802 27.4365 3.7606 22.1296L3.81585 22.0332L24.3822 33.7853L11.932 53.9349Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1888 31.0829H30.6504L37.0181 2.23499L37.1534 2.2647C43.6845 3.70824 49.5274 7.33749 53.716 12.5524C57.9046 17.7673 60.1881 24.2555 60.1888 30.9442V31.0829Z",
    fill: "#FFEB63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9447 26.5394L5.93066 15.1028L5.98446 15.0089C8.41084 10.7703 12.1273 7.41732 16.5923 5.4384C21.0574 3.45947 26.0377 2.95805 30.8076 4.00719L30.9133 4.03042L25.9447 26.5394Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.85 0.202881H75.0918V13.1835H100.85V0.202881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8075 3.52563H78.1357V4.19248H97.8075V3.52563Z",
    fill: "#FFEB63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8075 6.35974H78.1357V7.02658H97.8075V6.35974Z",
    fill: "#FFEB63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8075 9.19385H78.1357V9.86069H97.8075V9.19385Z",
    fill: "#FFEB63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.053 13.3863H74.8887V0H101.053V13.3863ZM75.2943 12.9806H100.647V0.405645H75.2943V12.9806Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7113 47.0485H36.3057V80.4407H36.7113V47.0485Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.992 6.70825L44.54 20.4818L44.7072 20.8514L75.1592 7.07785L74.992 6.70825Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11830_26243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158.689,
    height: 135,
    fill: "white",
    transform: "translate(0.655273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJfaJobFinder);
export default __webpack_public_path__ + "static/media/jfa-job-finder.37e5c3f757461e94a08ace036bc1e314.svg";
export { ForwardRef as ReactComponent };